// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditorPreview-module__previewContainer__uXPjD {
  position: absolute;
  background-color: white;
  z-index: 11;
  height: calc(100vh - 180px);
}
.EditorPreview-module__documentContainer__eQkkb {
  top: 54px;
  left: 0;
  height: 100% !important;
  z-index: 100;
  padding: 36px 0 36px 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  opacity: 1;
  background-color: #fafafa;
  overflow: auto;
  border-right: 2px solid #cbdbe1;
}
.EditorPreview-module__documentContainer__eQkkb .EditorPreview-module__document-viewer__pxcRP {
  width: 100%;
}
.EditorPreview-module__documentViewer__KMcbK {
  width: 100%;
  padding-top: 12px;
  padding-bottom: 12px;
  top: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.EditorPreview-module__documentViewer__KMcbK .EditorPreview-module__pdf-viewer__XoCne .EditorPreview-module__pdf-pagination-info__mH4qi {
  display: none !important;
}
.EditorPreview-module__closeIcon__InPgp {
  color: #bfbfbf;
  width: 24px;
  height: 24px;
  margin-left: 10px;
}
.EditorPreview-module__titleContainer__P8MdK {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  border-bottom: 1px solid #d9d9d9;
  padding: 6px 12px;
  position: sticky;
  top: 0;
  height: 54px;
}
.EditorPreview-module__viewRunButton__A1Ea3 {
  color: rgba(0, 0, 0, 0.85);
  border-color: rgba(0, 0, 0, 0.85);
  outline: none;
}
.EditorPreview-module__title__qclXo {
  font-weight: 500;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
}
.EditorPreview-module__backArrow__WXoud {
  width: 24px;
  height: 24px;
  margin: 0 10px 0 12px;
  cursor: pointer;
}
.EditorPreview-module__downloadButton__GVrrn {
  width: 24px;
  height: 24px;
  margin-left: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PlaygroundV3/components/EditorPreview/EditorPreview.module.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,2BAAA;AACF;AAEA;EACE,SAAA;EACA,OAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;EACA,cAAA;EACA,+BAAA;AAAF;AAEE;EACE,WAAA;AAAJ;AAIA;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AAFF;AALA;EAWM,wBAAA;AAHN;AAQA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AANF;AASA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;AAPF;AAUA;EACE,0BAAA;EACA,iCAAA;EACA,aAAA;AARF;AAWA;EACE,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AATF;AAYA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AAVF;AAaA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAXF","sourcesContent":[".previewContainer {\n  position: absolute;\n  background-color: white;\n  z-index: 11;\n  height: calc(100vh - 180px);\n}\n\n.documentContainer {\n  top: 54px;\n  left: 0;\n  height: 100% !important;\n  z-index: 100;\n  padding: 36px 0 36px 26px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  opacity: 1;\n  background-color: #fafafa;\n  overflow: auto;\n  border-right: 2px solid #cbdbe1;\n\n  & .document-viewer {\n    width: 100%;\n  }\n}\n\n.documentViewer {\n  width: 100%;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  top: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  .pdf-viewer {\n    .pdf-pagination-info {\n      display: none !important;\n    }\n  }\n}\n\n.closeIcon {\n  color: #bfbfbf;\n  width: 24px;\n  height: 24px;\n  margin-left: 10px;\n}\n\n.titleContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 500;\n  border-bottom: 1px solid #d9d9d9;\n  padding: 6px 12px;\n  position: sticky;\n  top: 0;\n  height: 54px;\n}\n\n.viewRunButton {\n  color: rgba(0, 0, 0, 0.85);\n  border-color: rgba(0, 0, 0, 0.85);\n  outline: none;\n}\n\n.title {\n  font-weight: 500;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: row;\n}\n\n.backArrow {\n  width: 24px;\n  height: 24px;\n  margin: 0 10px 0 12px;\n  cursor: pointer;\n}\n\n.downloadButton {\n  width: 24px;\n  height: 24px;\n  margin-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewContainer": `EditorPreview-module__previewContainer__uXPjD`,
	"documentContainer": `EditorPreview-module__documentContainer__eQkkb`,
	"document-viewer": `EditorPreview-module__document-viewer__pxcRP`,
	"documentViewer": `EditorPreview-module__documentViewer__KMcbK`,
	"pdf-viewer": `EditorPreview-module__pdf-viewer__XoCne`,
	"pdf-pagination-info": `EditorPreview-module__pdf-pagination-info__mH4qi`,
	"closeIcon": `EditorPreview-module__closeIcon__InPgp`,
	"titleContainer": `EditorPreview-module__titleContainer__P8MdK`,
	"viewRunButton": `EditorPreview-module__viewRunButton__A1Ea3`,
	"title": `EditorPreview-module__title__qclXo`,
	"backArrow": `EditorPreview-module__backArrow__WXoud`,
	"downloadButton": `EditorPreview-module__downloadButton__GVrrn`
};
export default ___CSS_LOADER_EXPORT___;
